angular.module('Itao.IndicatorMap').directive('districtSelect', ['mapConfig', 'communeConfig', function(mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtSelect.html',
    scope: {
      unselectedDistricts: '=',
      selectedDistrictKeys: '=',
      selectedDistricts: '=',
      onDistrictSelect: '&',
      onDistrictDeselect: '&'
    },
    link: function (scope) {
      scope.selectedDistrictKeys = scope.selectedDistrictKeys || [];
      scope.selectedDistricts = [];
      scope.searchterm = '';
      scope.showsearch = false;
      scope.searchfilter = function(searchterm) {
        return function(district) {
          var name = district.name.toLowerCase();
          var key = district.key.toLowerCase();
          var term = searchterm.toLowerCase();
          return (name.indexOf(term) !== -1) || (key.indexOf(term) !== -1);
        };
      };

      scope.test = function(district) {
        scope.onDistrictSelect({district: district})
      };
    }
  };
}]);
